import React from "react";
import useOptions from "./hooks/useOptions";
import ElementForm from "./ElementForm";
import { useParams } from "react-router-dom";
import LoadingComponent from "./LoadingComponent";
import ErrorComponent from "./ErrorComponent";
import { initialCreateFormData, pathMappings } from "./constants";
import Form from "./forms/Form";

const Create = () => {
  const { error, isLoading, options } = useOptions();
  const { tag } = useParams();

  if (isLoading) return <LoadingComponent />;

  if (error) return <ErrorComponent />;
  return (
    <Form
      options={options}
      initialData={initialCreateFormData[pathMappings[tag]]}
      edit={false}
      elementType={pathMappings[tag]}
    />
  );
};

export default Create;
